<div class="account-details-header">
  <h3 class="account-details-title">{{ 'user_details' | translate }}</h3>
  <p class="account-details-subtitle ods-typography-body-s-regular">{{ 'user_details_text' | translate }}</p>
</div>
<div class="account-details-body">
  <div class="account-details-user">
    <div class="account-details-user-avatar">
      <span *ngIf="!avatar" class="account-details-user-initials ods-typography-subtitle-l">{{ userInitials }}</span>
      <figure *ngIf="avatar" class="image contain-image">
        <img [src]="avatar" />
      </figure>
    </div>
    <div class="account-details-user-name">
      <span [title]="userFullName" class="account-details-user-name-text">{{ userFullName }}</span>
    </div>
  </div>

  <div class="account-details-fields-container">
    <mat-form-field class="account-details-field">
      <input disabled matInput [placeholder]="'cosmote_id_mobile' | translate" [value]="mobilePhone" />
    </mat-form-field>
    <mat-form-field class="account-details-field">
      <mat-label>{{ 'cosmote_id_email' | translate }}</mat-label>
      <input disabled matInput [value]="email" />
    </mat-form-field>
  </div>

  <div class="account-details-fields-container">
    <mat-form-field class="account-details-field">
      <mat-label>{{ 'first_name' | translate }}</mat-label>
      <input disabled matInput [value]="firstName" />
    </mat-form-field>
    <mat-form-field class="account-details-field">
      <mat-label>{{ 'last_name' | translate }}</mat-label>
      <input disabled matInput [value]="lastName" />
    </mat-form-field>
  </div>

  <button type="button" box-button theme="primary" (click)="navigateToProfile()">{{ 'edit_' | translate }}</button>
</div>
